/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi.com Payments API
 * An API for Kiwi.com payments.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CommonBookingInfoViewBasketBookingItemsInnerSegment interface.
 */
export function instanceOfCommonBookingInfoViewBasketBookingItemsInnerSegment(value) {
    return true;
}
export function CommonBookingInfoViewBasketBookingItemsInnerSegmentFromJSON(json) {
    return CommonBookingInfoViewBasketBookingItemsInnerSegmentFromJSONTyped(json, false);
}
export function CommonBookingInfoViewBasketBookingItemsInnerSegmentFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'arrivalCode': json['arrival_code'] == null ? undefined : json['arrival_code'],
        'departureCode': json['departure_code'] == null ? undefined : json['departure_code'],
    };
}
export function CommonBookingInfoViewBasketBookingItemsInnerSegmentToJSON(json) {
    return CommonBookingInfoViewBasketBookingItemsInnerSegmentToJSONTyped(json, false);
}
export function CommonBookingInfoViewBasketBookingItemsInnerSegmentToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'arrival_code': value['arrivalCode'],
        'departure_code': value['departureCode'],
    };
}
